import APP from 'src/main.js'
import AppRecord from 'stores/models/modelFiles/AppRecord.js'

class AccountBalance extends AppRecord {
  get account(){
    return this.constructor.employeeStore.accountsById.get(this.account_id)
  }

}
export default AccountBalance
